/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member-management.exit', {
            parent: 'member-management',
            url: '/exit?mode',
            data: {
                authorities: ['ROLE_BOARD'],
                pageTitle: 'askApp.memberManagement.exit.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/member-management/member-exit.html',
                    controller: 'MemberExitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                mode: {
                    value: '',
                    squash: false
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('member-management.exit.process', {
            parent: 'member-management.exit',
            url: '/process?members',
            data: {
                authorities: ['ROLE_BOARD']
            },
            params: {
                members: {
                    value: '',
                    squash: false
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/member-management/member-exit-dialog.html',
                    controller: 'MemberExitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
